var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{attrs:{"data-module":"global-menu"}},[_vm._v(_vm._s(_vm.$props))])
}
var staticRenderFns = []

export { render, staticRenderFns }